var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{staticClass:"date-picker",attrs:{"no-title":"","range":"","min":_vm.minDate,"max":_vm.maxDate,"show-adjacent-months":""},on:{"change":_vm.updateDateRange},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }